module.exports = __webpack_public_path__ + "static/media/busca-preto.7e3e93c5.svg";